module.exports = __webpack_public_path__ + "static/media/sports.f01b2d6d.png";